import React, { useState } from 'react';

const SCORE_CATEGORIES = [
  { key: 'name_match_score', label: 'Name', abbr: 'Nm', max: 2, desc: 'Person match: 2 = exact first + last name, 1 = fuzzy first name + exact last name, -8 = award names a different person' },
  { key: 'purpose_match_score', label: 'Purpose', abbr: 'Pur', max: 3, desc: 'Purpose: 2 = exact, 1 = fuzzy, +1 if the fund lists tiers and Tier 1 matches' },
  { key: 'program_match_score', label: 'Program', abbr: 'Prg', max: 2, desc: 'Program/organization: 2 = exact, 1 = fuzzy' },
  { key: 'restriction_score', label: 'Restriction', abbr: 'Rst', max: 2, desc: '2 = Highly Restricted award, 1 = Moderately Restricted' },
  { key: 'age_score', label: 'Age', abbr: 'Age', max: 1, desc: 'Bonus for newer awards (up to 10 years)' },
  { key: 'semantic_score', label: 'Semantic/Vector', abbr: 'Sem', max: 2, desc: 'AI-based semantic similarity score (LLM or vector embedding)' },
];

export default function ScoreLegend() {
  const [visible, setVisible] = useState(false);

  return (
    <div className="score-legend-wrap">
      <button
        className="detail-toggle-btn"
        onClick={() => setVisible(!visible)}
        aria-expanded={visible}
        aria-haspopup="true"
        style={{ fontSize: 11 }}
      >
        {visible ? 'Hide Legend' : 'Score Legend'}
      </button>
      {visible && (
        <div className="score-legend">
          {SCORE_CATEGORIES.map(cat => (
            <div key={cat.key} className="score-legend-item">
              <div className="score-legend-header">
                <span className="score-legend-abbr">{cat.abbr}</span>
                <span className="score-legend-label">{cat.label}</span>
                <span className="score-legend-max">0-{cat.max}</span>
              </div>
              <div className="score-legend-desc">{cat.desc}</div>
              <div className="score-legend-bar">
                <div className="score-legend-bar-segment high" style={{ width: `${(1 / cat.max) * 100}%` }} />
                <div className="score-legend-bar-segment mid" style={{ width: `${(1 / cat.max) * 100}%` }} />
                {cat.max > 2 && <div className="score-legend-bar-segment low" style={{ width: `${(1 / cat.max) * 100}%` }} />}
              </div>
            </div>
          ))}
          <div className="score-legend-colors">
            <span className="score-legend-color-item"><span className="score-color-dot high" /> High match</span>
            <span className="score-legend-color-item"><span className="score-color-dot mid" /> Moderate</span>
            <span className="score-legend-color-item"><span className="score-color-dot low" /> No match</span>
          </div>
        </div>
      )}
    </div>
  );
}

export { SCORE_CATEGORIES };
